import {
  createRootRouteWithContext,
  Outlet,
  redirect,
} from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/router-devtools";
import type { QueryClient } from "@tanstack/react-query";
import { tokenStore } from "@/lib/api";

// ─── Router context ───────────────────────────────────────────────────────────

interface RouterContext {
  queryClient: QueryClient;
}

// ─── Root route ───────────────────────────────────────────────────────────────
// Auth guard: unauthenticated → /login; already authed on /login → /

export const Route = createRootRouteWithContext<RouterContext>()({
  beforeLoad: ({ location }) => {
    const isLoginPage = location.pathname === "/login";
    const isPublicOrder = location.pathname === "/ordenar";
    const hasToken    = !!tokenStore.get();

    if (!hasToken && !isLoginPage && !isPublicOrder) {
      throw redirect({ to: "/login" });
    }
    if (hasToken && isLoginPage) {
      throw redirect({ to: "/" });
    }
  },
  component: RootComponent,
});

function RootComponent() {
  return (
    <>
      <Outlet />
      {import.meta.env.DEV && (
        <TanStackRouterDevtools position="bottom-right" />
      )}
    </>
  );
}
